import React, { useState } from 'react';
import { Collapse, Grid, Typography, useTheme } from '@mui/material'
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import FilePath from './filePathComponents/FilePath';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

export default function FilePaths(props: any) {
    const { imagePaths, cloudPaths, xmlPaths, rawImagePaths, rawCloudPaths, rawXmlPaths, pdfPaths, rawPdfPaths, fullWidth = false } = props;
    const [open, setOpen] = useState<boolean>(false);
    const { t } = useTranslation();
    const theme = useTheme();

    const handleClick = () => {
        setOpen(!open);
    };

    return (
        <Grid
            container
            direction="row"
            justifyContent="space-evenly"
            alignItems="center"
            sx={{ mt: 1 }}
        >
            <Grid item md={fullWidth ? 12 : 11} xs={12} >
                <ListItemButton
                    sx={{
                        backgroundColor: 'var(--spectre-surface)',
                        borderRadius: 1,
                        color: theme.palette.spectre.textPrimary,
                    }}
                    onClick={handleClick}
                >
                    <ListItemText>
                        <Typography color="inherit" fontWeight={600}>{t('control.centerControl.files')}</Typography>
                    </ListItemText>
                    {open ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
                <Collapse in={open} timeout="auto" unmountOnExit>
                    <Grid container spacing={1.5} sx={{ pt: 1.5 }}>
                        {imagePaths.map((path: string, index: number) => {
                            return (
                                <FilePath key={`image-${path}`} path={path} rawPath={rawImagePaths[index]}></FilePath>
                            )
                        })}
                        {cloudPaths.map((path: string, index: number) => {
                            return (
                                <FilePath key={`cloud-${path}`} path={path} rawPath={rawCloudPaths[index]}></FilePath>
                            )
                        })}
                        {xmlPaths.map((path: string, index: number) => {
                            return (
                                <FilePath key={`xml-${path}`} path={path} rawPath={rawXmlPaths[index]}></FilePath>
                            )
                        })}
                        {pdfPaths.map((path: string, index: number) => {
                            return (
                                <FilePath key={`pdf-${path}`} path={path} rawPath={rawPdfPaths[index]}></FilePath>
                            )
                        })}
                    </Grid>
                </Collapse>
            </Grid>
        </Grid>
    )
}